import {
  BusinessTwoTone,
  FactoryTwoTone,
  HelpTwoTone,
  HomeTwoTone,
  HotelTwoTone,
  LocalHospitalTwoTone,
  LocalShippingTwoTone,
  SchoolTwoTone,
  ScienceTwoTone,
  StoreTwoTone,
} from '@mui/icons-material'

export const getKindOfUseIcon = (usage: string) => {
  switch (usage) {
    case 'Büro':
      return <BusinessTwoTone />
    case 'Gesundheitswesen':
      return <LocalHospitalTwoTone />
    case 'Hotel':
      return <HotelTwoTone />
    case 'Industrie':
      return <FactoryTwoTone />
    case 'Logistik':
      return <LocalShippingTwoTone />
    case 'Testgelände':
      return <ScienceTwoTone />
    case 'Unterrichtsgebäude':
      return <SchoolTwoTone />
    case 'Verkaufsgebäude':
      return <StoreTwoTone />
    case 'Wohngebäude':
      return <HomeTwoTone />
    default:
      return <HelpTwoTone />
  }
}
